/** @format */

import { createContext } from 'react';

const RouteContext = createContext({});

export default RouteContext;
